import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as PendingDeductionBulkUploadActions from "../../store/actions/PendingDeductionBulkUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const PendingDeductionBulkUploadDashboard = ({ getBulkUploadUrl }) => {
  const filterTypes = ["NON_TDS", "NON_ORDER", "ORDER"];
  const filterTypeSampleCsvUrlMap = {
    NON_TDS: "/sample/pending_deduction_ledgers.csv",
    NON_ORDER: "/sample/non_order_ledgers.csv",
    ORDER: "/sample/order_ledgers.csv",
  };

  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="PendingDeductionBulkUploadBtn"
      uploadUrl="/driver-accounting/pending-deduction-ledgers/bulk-upload-ack"
      filename="pending_deduction_ledgers"
      id="PendingDeductionBulkUploadModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Pending Deduction Bulk Upload"
      getUploadUrl={getBulkUploadUrl}
      closeUrl={"/pending-deduction"}
      filterTypes={filterTypes}
      filterTypeSampleCsvUrlMap={filterTypeSampleCsvUrlMap}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      PendingDeductionBulkUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(PendingDeductionBulkUploadDashboard);
